/* NetworkDiscoveryResultsViewComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./NetworkDiscoveryResultsViewRenderer");
const DeviceStateColumnRenderer = require("./column_renderers/device_status/DeviceStatusComponent");
const DiscoveryStateColumnRenderer = require("./column_renderers/discovery_status/DiscoveryStatusComponent");
const DateColumn = require("./column_renderers/date/DateComponent");
const PagingNetworkDiscoveryResultsFeed = require("./PagingNetworkDiscoveryResultsFeed");
const DeviceTypeColumn = require("./column_renderers/device_type/DeviceTypeComponent");
const DEVICE_NAME_MAX_LENGTH = 60;
const DEVICE_NAME_LIST_LENGTH = 10;
const LinksColumn = require("./column_renderers/links/LinksComponent");
const ImportScreenComponent = require("./veils/import_screen/ImportScreenComponent");
const FileName = require("@gluenetworks/steve_utilities").fileName;
let nonImportableDeviceStatus = ["PENDING", "KNOWN", "IMPORTING", "ERROR"];

class NetworkDiscoveryResultsViewComponent extends EventEmitter {
    constructor(
        logger,
        gameEditor,
        userSession,
        LicenseRestriction,
        MUF,
        solutionsManager,
        storageFactory,
        steveIo,
        reportService,
        NetworkDiscoveryResult,
        DeviceEntity,
        NetworkDiscoveryExecution
    ) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = MUF;

        this._Device = DeviceEntity;

        this._userSession = userSession;
        this._licenseRestriction = LicenseRestriction;

        this._storageFactory = storageFactory;
        this._networkDiscoveryResultsEntityDef = NetworkDiscoveryResult;
        this._isOSMSolutionAvailable = this._licenseRestriction.checkLicense("OSM");

        this._networkDiscoveryPlanFeed = undefined;

        this._networkDiscoveryExecutionFeed = undefined;
        this._networkDiscoveryExecutionEntity = this._gameEditor._networkDiscoveryExecutionEntity;
        this._networkDiscoveryExecutionEntityDef = NetworkDiscoveryExecution;

        this._networkDiscoveryResultsFeed = undefined;
        this._fileNamer = FileName;

        this._fileFactory = steveIo.fileFactory;
        this._file = steveIo.File;
        this._reportService = reportService;

        this._device = undefined;

        this._planRunning = false;

        this._selectedIds = [];
        this._runningStart = this._gameEditor._runningStart;
        // TODO Quick hack to customize DeviceDetailsView based on its parent solution (Device Manager or Config Drift)
        // To be refactored with separate views once form layout / style specifications have matured
        this._solutionDefinition = solutionsManager.getActiveSolution();
        this._solutionName = this._solutionDefinition.name || "";

        this._gridKey = _.camelCase(this._solutionName) + "_" + "networkDiscovery";

        this._userGridData = undefined;
        // this._sessionStorage = undefined;

        //creating a new static DEVICE_TYPES list to pass to filter dropdown for types (via options)
        //TODO: create a non-redundant list directly in the filter
        let typeBaseGroupMap = _.get(this._Device, "typeBaseGroupMap");
        let optionFilterList = {};
        Object.keys(typeBaseGroupMap).map(function (key) {
            optionFilterList[key] = {name: key, title: key};
        });

        this.columns = {
            detectedTypeBase: {
                label: "Type",
                columnRendererComponent: DeviceTypeColumn,
                entityColumn: true,
                width: 45,
                resizable: false,
                priority: 0,
                options: optionFilterList,
                shown: true,
            },
            deviceName: {
                label: "Name",
                shown: true,
                width: 140,
                priority: 1,
                resizable: true,
                dataType: "string",
                entityColumn: false,
            },
            "connectionInformation.ip": {
                label: "IP Address",
                path: "connectionInformation.ip",
                shown: true,
                width: 140,
                priority: 2,
                resizable: true,
                dataType: "string",
            },
            detectedVendor: {
                label: "Vendor",
                width: 100,
                resizable: true,
                priority: 3,
                shown: true,
                dataType: "string",
            },
            macAddress: {
                label: "MAC Address",
                shown: true,
                width: 140,
                priority: 4,
                resizable: true,
                dataType: "string",
            },
            discoverySource: {
                label: "Source",
                shown: true,
                width: 140,
                priority: 5,
                resizable: true,
                dataType: "string",
            },
            detectedHostName: {
                label: "Hostname",
                shown: true,
                width: 140,
                priority: 6,
                resizable: true,
                dataType: "string",
                entityColumn: false,
            },
            detectedSku: {
                label: "SKU",
                shown: true,
                width: 140,
                priority: 7,
                resizable: true,
                dataType: "string",
            },
            detectedSerialNumber: {
                label: "Serial",
                shown: true,
                width: 140,
                priority: 8,
                resizable: true,
                dataType: "string",
            },
            discoveryDepth: {
                label: "Level",
                shown: true,
                width: 140,
                priority: 9,
                resizable: true,
                dataType: "string",
            },
            elementCount: {
                label: "Element Count",
                shown: true,
                width: 140,
                priority: 9,
                resizable: true,
                dataType: "string",
            },
            discoveryStatus: {
                label: "Discovery Status",
                shown: true,
                width: 140,
                priority: 10,
                resizable: true,
                dataType: "string",
                columnRendererComponent: DiscoveryStateColumnRenderer,
                entityColumn: true,
            },
            deviceStatus: {
                label: "Inventory State",
                shown: true,
                width: 140,
                priority: 11,
                resizable: true,
                dataType: "string",
                columnRendererComponent: DeviceStateColumnRenderer,
                entityColumn: true,
            },
            neighborCount: {
                label: "Neighbor Count",
                shown: true,
                width: 140,
                priority: 12,
                resizable: true,
                dataType: "string",
            },
            createdOn: {
                label: "Discovered On",
                columnRendererComponent: DateColumn,
                shown: true,
                width: 160,
                priority: 13,
            },
            planName: {
                label: "Discovery Plan",
                shown: true,
                width: 200,
                priority: 14,
                resizable: true,
                dataType: "string",
                entityColumn: false,
            },
            Log: {
                label: "Log",
                priority: 154,
                entityColumn: true,
                resizable: false,
                columnRendererComponent: LinksColumn,
                context: {
                    gameEditor: this._gameEditor,
                },
            },
        };

        this._onLastWorkIdUpdated = this._onLastWorkIdUpdated.bind(this);

        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        this._gameEditor._editorLayout.on(
            "UserSelectedRows",
            (this._onGridRowClicked = this._onGridRowClicked.bind(this))
        );

        // this._gameEditor.on(
        //     "NetworkExecutionFeedUpdated",
        //     (this._onNetworkExecutionFeedUpdated = _.debounce(this._onNetworkExecutionFeedUpdated.bind(this), 400, false))
        // );
    }

    _unregisterListeners() {
        this._gameEditor._editorLayout.removeListener("UserSelectedRows", this._onGridRowClicked);
        // this._gameEditor.removeListener("NetworkExecutionFeedUpdated", this._onNetworkExecutionFeedUpdated);
    }

    _registerFeedListeners() {
        this._unregisterFeedListeners();
        this._networkDiscoveryPlanFeed.on(
            "PristinePropertiesChanged",
            (this._onPristinePropertiesChanged = this._onPristinePropertiesChanged.bind(this))
        );
        this._networkDiscoveryPlanFeed.on(
            "Dirty",
            (this._onDirtyStateChanged = this._onDirtyStateChanged.bind(this))
        );
        this._networkDiscoveryPlanFeed.on("LastWorkIdPropertyUpdated", this._onLastWorkIdUpdated);
    }

    _unregisterFeedListeners() {
        this._networkDiscoveryPlanFeed.removeAllListeners("PristinePropertiesChanged");
        this._networkDiscoveryPlanFeed.removeListener("Dirty", this._onDirtyStateChanged);
        this._networkDiscoveryPlanFeed.removeAllListeners("LastWorkIdPropertyUpdated");
    }

    _registerResultsFeedListeners() {
        this._unregisterResultsFeedListeners();
        this._networkDiscoveryResultsFeed._feed.on(
            "EntityPropertiesUpdated",
            (this._onResultsFeedUpdated = this._onResultsFeedUpdated.bind(this))
        );
    }

    _unregisterResultsFeedListeners() {
        this._networkDiscoveryResultsFeed._feed.removeAllListeners("EntityPropertiesUpdated");
    }

    _onResultsFeedUpdated() {
        this.emit("ResultsFeedUpdated");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        if (
            !_.isUndefined(this._networkDiscoveryPlanFeed) &&
            !_.isEmpty(this._networkDiscoveryPlanFeed)
        ) {
            this._unregisterFeedListeners();
        }
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._device = undefined;
                this._logger = undefined;
                this._gameEditor = undefined;
                this._renderer = undefined;
                this._networkDiscoveryExecutionFeed = undefined;
                this._networkDiscoveryPlanFeed = undefined;
                this._runningStart = undefined;
                this._userGridData = undefined;
                // this._sessionStorage = undefined;
            },
            (err) => {
                this._logger.warn(err, "DeviceDetailsViewComponent.shutdown() error.");
            }
        );
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onLastWorkIdUpdated() {
        this._gameEditor._currentDiscoveryWorkId = this._networkDiscoveryPlanFeed.lastWorkId;
    }

    _onPendingPatchesChanged() {
        // TODO - this is a quick hack because the Array ref adapter does a shutdown and complete rebuild every time you call setValue. the effect to the user is they lose focus in the proxy list if they stop typing longer than the debounce
        // this.emit('DevicePropertiesChanged');
    }

    _onPristinePropertiesChanged(pristineProperties, before) {
        if (pristineProperties.status === "RUNNING" || pristineProperties.status === "CANCELING") {
            this._gameEditor.disableViewAction("excludeSelection");
        } else {
            this._gameEditor.enableViewAction("excludeSelection");
        }
        this.emit("NetworkDiscoveryPropertiesChanged", pristineProperties, before);
    }

    _onOsImageServerFeedUpdated(/*entity, patches, props, feed*/) {
        //console.log(entity, patches, props, feed);
        this.emit("OsImageServerFeedUpdated");
    }

    _onGridRowClicked(clickedRows) {
        this.gameEditor.retrieveDevice(clickedRows.selectedRows[0]).then((device) => {
            this._device = device;
            this.emit("DeviceUpdated");
        });
    }

    _onDirtyStateChanged(newVal) {
        this.emit("DirtyStateChanged", newVal);
    }

    _onNetworkExecutionFeedUpdated() {
        // this.emit("Render");
        this.emit("ExecutionFeedUpdated");
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    downloadGridAsCSV(columnOrder = [], showKnownDevices = true) {
        return this._networkDiscoveryResultsFeed.fetchAllEntityIds().then((ids) => {
            if (_.isArray(ids) && ids.length > 0) {
                const reportName = "Network Discovery Result List",
                    organizationId = this._userSession.activeOrganization.id;
                // fileNamePrefix = "NetworkDiscoveryResult";

                let query = {id: {$in: ids}};
                if (showKnownDevices === false) {
                    query = {$and: [{id: {$in: ids}}, {deviceStatus: {$ne: "KNOWN"}}]};
                }

                let reportParams = {
                    reportName,
                    organizationId,
                    columnOrder,
                    query,
                    tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
                };

                return this._reportService.report(reportParams).then((result) => {
                    let fileName = this._fileNamer({
                        solution: "DM",
                        general: "NetworkDiscoveryResultReport",
                        suffix: "csv",
                    });
                    // let fileName = fileNamePrefix + "Report-" + new Date().toISOString() + ".csv";
                    let file = new this._file(fileName, null, result);
                    this._fileFactory.saveFile(file);
                    return Promise.resolve();
                });
            }
        });
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    isDirty() {
        return this._device.isDirty();
    }

    get gameEditor() {
        return this._gameEditor;
    }

    get logger() {
        return this._logger;
    }

    get pagingFeed() {
        return this._networkDiscoveryResultsFeed;
    }

    get activeOrgId() {
        return this._userSession.activeOrganization.id;
    }

    _getResultsFeed(
        filterQuery /* executionEntity = this._gameEditor._networkDiscoveryExecutionEntity*/
    ) {
        const userSorting = /* this._userGridData.getSorting() || */ {};

        this._patchSorting(userSorting);

        const additionalDataFields = ["name", "detectedRawTypeBase", "planId"];

        this._networkDiscoveryResultsFeed = new PagingNetworkDiscoveryResultsFeed({
            feedKey: this._gridKey + "_feed",
            entityDef: this._networkDiscoveryResultsEntityDef,
            columnConfig: this.columns,
            filter: filterQuery,
            activeOrgId: this.activeOrgId,
            additionalDataFields,
            sort: userSorting,
        });
        this._registerResultsFeedListeners();
        return this._networkDiscoveryResultsFeed.whenFeedReady();
    }

    async whenModelIsReady(filterQuery, isCurrentPlanOnly) {
        if (!this._networkDiscoveryPlanFeed) {
            this._networkDiscoveryPlanFeed = await this.gameEditor.whenGameEditorReady();
            this._gameEditor._currentDiscoveryWorkId = this._networkDiscoveryPlanFeed.lastWorkId;
        }
        if (isCurrentPlanOnly) {
            filterQuery.$and.push({planId: {$eq: this._networkDiscoveryPlanFeed.id}});
        }
        if (!this._networkDiscoveryResultsFeed) {
            this._networkDiscoveryResultsFeed = await this._getResultsFeed(filterQuery);
        }

        this._registerFeedListeners();
        return Promise.resolve({resultFeed: this._networkDiscoveryResultsFeed, filterQuery});
    }

    updateEntity() {
        return Promise.resolve().then(() => {
            if (this._networkDiscoveryPlanFeed.isDirty()) {
                if (this._networkDiscoveryPlanFeed.clearSettingsRelationship) {
                    return this._networkDiscoveryPlanFeed
                        .clearSettingsRelationship()
                        .updateRelationships()
                        .then(() => {
                            return this._networkDiscoveryPlanFeed.update();
                        });
                } else {
                    return this._networkDiscoveryPlanFeed.update();
                }
            }
            return Promise.resolve();
        });
    }

    runNetworkDiscoveryWork() {
        this._gameEditor._workLog = [];
        this._gameEditor._myRunPlan = true;

        return this.updateEntity().then(() => {
            let workTarget = {
                category: "entity",
                entityType: "NetworkDiscoveryPlan",
                method: "single",
                id: this._networkDiscoveryPlanFeed.id,
            };

            const progressCB = (data) => {
                // const { successCount, failureCount, targetCount } = data;
                // this._logger.info("Discovery Progress", successCount, failureCount, targetCount);
                if (data.workId) {
                    this._networkDiscoveryPlanFeed.setStatus("RUNNING");
                    this._gameEditor._currentDiscoveryWorkId = data.workId;
                    // this.gameEditor.retrieveNetworkDiscoveryExecutionEntity(true);
                    this.emit("DiscoveryStarted");
                }

                this.emit("NetworkDiscoveryCompleted");
            };

            const workInput = {
                tenantId: this.activeOrgId,
                id: this._networkDiscoveryPlanFeed.id,
                description: `Network Discovery work for ${this.activeOrgId}`,
            };

            return this._gameEditor._networkDiscoveryPlan.runNetworkDiscoveryWork(
                this.activeOrgId,
                workTarget,
                workInput,
                {launchAndForget: false},
                progressCB
            );
        });
    }

    cancelNetworkDiscoveryWork() {
        if (this._gameEditor._currentDiscoveryWorkId) {
            this._modalUserFeedback
                .displayConfirmation(
                    "All running Network Discovery jobs will be canceled immediately. Are you sure you want to continue?",
                    {
                        title: "Cancel Network Discovery",
                        confirmDetails: {
                            text: "Confirm",
                            type: "destructive",
                        },
                        rejectDetails: {
                            text: "Cancel",
                        },
                    }
                )
                .then(() => {
                    this._gameEditor._networkDiscoveryPlan.cancelWork(
                        this.activeOrgId,
                        this._gameEditor._currentDiscoveryWorkId
                    );
                    this._gameEditor._currentDiscoveryWorkId = undefined;
                })
                .catch((err) => {
                    this._logger.warn(err);
                });
        }
    }

    async updateSelectedRows(selectedIds, isCurrentPlan) {
        this._selectedIds = selectedIds;
        if (_.isEmpty(selectedIds.selectedRows)) {
            this._gameEditor.disableViewAction("importSelection");
            this._gameEditor.disableViewAction("excludeSelection");
        } else {
            const ids = selectedIds.selectedRows;
            const query = {
                $and: [{id: {$in: ids}}, {deviceStatus: {$nin: nonImportableDeviceStatus}}],
            };
            const importableResults =
                await this._networkDiscoveryResultsEntityDef.loadNetworkDiscoveryResults(
                    this.activeOrgId,
                    query,
                    {id: true},
                    {},
                    {skip: 0, limit: 1}
                );
            if (importableResults.length > 0) {
                this._gameEditor.enableViewAction("importSelection");
            } else {
                this._gameEditor.disableViewAction("importSelection");
            }
            if (isCurrentPlan) {
                if (
                    this._networkDiscoveryPlanFeed.status !== "RUNNING" &&
                    this._networkDiscoveryPlanFeed.status !== "CANCELING"
                ) {
                    this._gameEditor.enableViewAction("excludeSelection");
                }
            } else {
                this._gameEditor.disableViewAction("excludeSelection");
            }
        }
    }

    _checkIfLicenseExceed(ids /*licenseFeed*/) {
        if (!ids) {
            ids = this._selectedIds.selectedRows;
        }
        let veilMessage;
        //return licenseFeed.whenInitialized().then((feed) => {
        return this._licenseRestriction.whenLicenseFeedIsReady().then(() => {
            //if (Object.values(_.get(feed, "cache", {})).length > 0) {
            if (this._licenseRestriction.checkLicense("GLUWARE")) {
                //const gluLicense = Object.values(_.get(feed, "cache", {})).filter((license) => license.licenseType === "Gluware")[0];
                const gluLicense = _.get(this._licenseRestriction._licenseData, "GLUWARE");
                let availableLicenses;
                if (gluLicense) {
                    if (gluLicense.totalLicenses === "Unlimited") {
                        availableLicenses = Infinity;
                    } else {
                        availableLicenses =
                            parseInt(gluLicense.totalLicenses, 10) - gluLicense.inUseLicenses;
                    }
                }
                const discoveryEntities =
                    this._networkDiscoveryResultsFeed.getNetworkDiscoveryResultsEntitiesById(ids);
                let totalElements = 0;
                for (let x = 0; x < discoveryEntities.length; x++) {
                    let elementCount = discoveryEntities[x].getElementCount();
                    if (_.isNumber(elementCount)) {
                        totalElements += Math.max(elementCount, 1);
                    } else {
                        totalElements += 1;
                    }
                }
                if (!availableLicenses || availableLicenses < totalElements) {
                    veilMessage = `The number of devices to be imported exceeds the number available under your license.\
                        Not all devices will be imported.\
                        Do you wish to continue?`;
                }
                return Promise.resolve(veilMessage);
            } else {
                return Promise.reject("Some problems with your license");
            }
        });
    }

    _onUserSorted(sortData) {
        sortData = [].concat(sortData);
        let sort = {};

        sortData.forEach((sortData) => {
            if (!sortData || !sortData.sortColumn || !this.columns[sortData.sortColumn]) {
                return;
            }
            const sortCriteria =
                this.columns[sortData.sortColumn].valuePath ||
                this.columns[sortData.sortColumn].path ||
                sortData.sortColumn;
            sort[sortCriteria] = sortData.sort === "asc" ? 1 : -1;
        });

        this._patchSorting(sort);

        this.pagingFeed.setSort(sort);
    }

    _patchSorting(sorting) {
        if (sorting && Object.keys(sorting).length === 1 && !sorting.firstPublished) {
            sorting.firstPublished = -1;
        }

        if (!_.isEmpty(sorting) && !sorting.id) {
            sorting.id = 1;
        }
    }

    _getImportVeilMessage(ids) {
        if (!ids) {
            ids = this._selectedIds.selectedRows;
        }
        if (ids.length > 0 && ids.length <= DEVICE_NAME_LIST_LENGTH) {
            const selectedDeviceNames =
                this._networkDiscoveryResultsFeed.getDeviceEntitiesNameById(ids);
            if (Array.isArray(selectedDeviceNames) && selectedDeviceNames.length > 0) {
                let s = selectedDeviceNames.length > 1 ? "s" : "";
                let msg = "Are you sure you want to import the selected device" + s + "?\n";
                Object.keys(selectedDeviceNames).forEach((id) => {
                    let deviceName = selectedDeviceNames[id];
                    let shortDeviceName =
                        deviceName && deviceName.length > DEVICE_NAME_MAX_LENGTH
                            ? deviceName.substr(0, DEVICE_NAME_MAX_LENGTH) + "…"
                            : deviceName;
                    msg += "\n" + shortDeviceName;
                });
                return Promise.resolve(msg);
            } else {
                return Promise.reject(new Error("Cannot retrieve the selected devices"));
            }
        } else {
            return Promise.resolve(
                `Are you sure you want to import the selected ${ids.length} devices?\n`
            );
        }
    }

    async excludeResults() {
        // runExcludeResultsWork
        try {
            const selectedResultIds = this._selectedIds.selectedRows;
            const workInput = {
                resultIds: selectedResultIds,
            };

            this._networkDiscoveryPlanFeed.runExcludeResultsWork(workInput).then((res) => {
                this._logger.info(res);
            });
            this.emit("ResetSelectedRows");
        } catch (err) {
            this._logger.warn(err);
        }
    }

    async clearResults() {
        this._modalUserFeedback
            .displayConfirmation(
                "Are you sure you want to delete all the results from the current plan?"
            )
            .then(() => {
                return this._modalUserFeedback.hideDisplayed();
            })
            .then(async () => {
                this._modalUserFeedback.displayLoading();
                const executions = await this._networkDiscoveryPlanFeed.loadRelatedExecutions();
                const executionIds = executions.map((exec) => exec.id);
                const progressCb = ({/*msg,*/ successCount, /* failureCount,*/ targetCount}) => {
                    // this._logger.info(msg);
                    // this._logger.info("Clearing results", successCount, failureCount, targetCount);
                    this._modalUserFeedback.showLoadingProgress(
                        `Clear results progress: ${successCount} of ${targetCount}`
                    );
                };
                let workTarget = {
                    category: "entity",
                    entityType: "NetworkDiscoveryExecution",
                    method: "multi",
                    ids: executionIds,
                };
                await this._networkDiscoveryExecutionEntityDef.runDeleteNetworkDiscoveryExecutionsWork(
                    this.activeOrgId,
                    workTarget,
                    {},
                    progressCb
                );
            })
            .catch((err) => {
                this._logger.warn(err);
            })
            .finally(() => {
                this._modalUserFeedback.hideDisplayed();
            });
    }

    async importAction() {
        if (!_.isEmpty(this._selectedIds) && !_.isEmpty(this._selectedIds.selectedRows)) {
            const ids = this._selectedIds.selectedRows;
            const importableResults =
                await this._networkDiscoveryResultsEntityDef.loadNetworkDiscoveryResults(
                    this.activeOrgId,
                    {$and: [{id: {$in: ids}}, {deviceStatus: {$nin: nonImportableDeviceStatus}}]},
                    {id: true}
                );
            const importableIds = importableResults.map((res) => res.id);
            Promise.resolve()
                .then(() => {
                    //let licenseFeed = this._licenseRestriction._retrieveLicenseStateData(this._gameEditor.activeOrgId);
                    return this._checkIfLicenseExceed(/*licenseFeed*/ importableIds).then(
                        (veilMessage) => {
                            if (veilMessage) {
                                return Promise.resolve(veilMessage);
                            }
                            return this._getImportVeilMessage(importableIds);
                        }
                    );
                })
                .then((message) => {
                    let importScreenComponent = new ImportScreenComponent(this._logger, message);
                    return this._modalUserFeedback.displayCustom(importScreenComponent, {
                        dontHide: true,
                    });
                })
                .then((param) => {
                    // eslint-disable-next-line no-unused-vars
                    let resultSummary;
                    let isCapturing = false;
                    const progressCB = ({msg, successCount, failureCount, targetCount}) => {
                        if (msg === "Starting Capture") {
                            isCapturing = true;
                        }
                        if (!isCapturing) {
                            this._logger.info(
                                "importAction progress",
                                successCount,
                                failureCount,
                                targetCount
                            );
                            this._modalUserFeedback.showLoadingProgress(
                                `Import action progress: ${successCount} of ${targetCount}`
                            );
                        } else {
                            this._logger.info(
                                "Capture action progress",
                                successCount,
                                failureCount,
                                targetCount
                            );
                            this._modalUserFeedback.showLoadingProgress(
                                `Capture action progress: ${successCount} of ${targetCount}`
                            );
                        }
                    };

                    const workInput = {
                        tenantId: this.activeOrgId,
                        id: importableIds || [],
                        description: `Network Discovery Import work`,
                        captureAfterImport: param.needSnapshot || false,
                    };

                    const workTarget = {
                        method: "multi",
                        ids: importableIds || [],
                    };
                    return this._modalUserFeedback
                        .displayLoading()
                        .then(() => {
                            return this._networkDiscoveryResultsEntityDef.runImportDiscoveredDeviceWork(
                                this.activeOrgId,
                                workTarget,
                                workInput,
                                {launchAndForget: false},
                                progressCB
                            );
                        })
                        .then((result) => {
                            resultSummary = result;
                            return Promise.resolve(result);
                        });
                })
                .then((resultSummary) => {
                    if (!resultSummary) {
                        return Promise.resolve();
                    }
                    let errorDetails = "";
                    if (resultSummary.summary.targetCount > resultSummary.summary.successCount) {
                        const targetDeviceIds = Object.keys(resultSummary.targets);
                        let targetResult;
                        errorDetails = targetDeviceIds.reduce((errors, deviceId) => {
                            targetResult = _.get(resultSummary, `targetResults[${deviceId}]`);
                            if (
                                _.isArray(targetResult) &&
                                targetResult[0] &&
                                targetResult[0].status !== "success"
                            ) {
                                return (errors += `${resultSummary.targets[deviceId].name}: \
                                ${targetResult[0].status}, \
                                ${targetResult[0].errorMsg}\n`);
                            } else {
                                return "";
                            }
                        }, "");
                    }
                    let summaryString = `\
                    Total Devices: ${resultSummary.summary.targetCount}
                    Imported: ${resultSummary.summary.successCount}
                    Failed: ${resultSummary.summary.failureCount}
                    Missing: ${resultSummary.summary.missingTargetCount}
                    Newly Created: ${resultSummary.summary.deviceCreateCount}
                    Updated: ${resultSummary.summary.deviceUpdateCount}
                    Exceeded: ${resultSummary.summary.exceededDeviceCount}
                    `;

                    if (errorDetails) {
                        summaryString += `
                        Error Details
                        ${errorDetails}
                        `;
                    }

                    this.emit("ImportComplete");
                    return this._modalUserFeedback.displayNotification(summaryString, {
                        title: "Device Import Summary",
                    });
                })
                .catch((error) => {
                    this._modalUserFeedback.hideDisplayed();
                    if (!error.userRejected) {
                        this._logger.warn({error}, "Results View::Import Error");
                    }
                });
        }
    }

    _setViewActionText(buttonValue, buttonText) {
        this._gameEditor._setViewActionText(buttonValue, buttonText);
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = NetworkDiscoveryResultsViewComponent;

NetworkDiscoveryResultsViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.userSession",
    "$teve.licenseRestriction",
    "$teve.ui.userFeedback",
    "$teve.solutionsManager",
    "$teve.storageFactory",
    "$teve.io",
    "$teve.services.instance.Report",
    "$teve.entities.NetworkDiscoveryResult",
    "$teve.entities.Device",
    "$teve.entities.NetworkDiscoveryExecution",
];

NetworkDiscoveryResultsViewComponent.$displayDetails = {
    type: "View",
    name: "Network Discovery Results",
    icon: "common.results_link",
    shown: true,
    title: "Results",
    order: 3,
};
